import { useEffect } from 'react';

import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
// eslint-disable-next-line jira/wrm/no-load-bridge
import {
	loadBridge,
	loadBridgeWeak,
	waitForHeritage,
	type LoadBridgeOptions,
} from '@atlassian/jira-common-bridge/src';
import { fg } from '@atlassian/jira-feature-gating';
import { useLocale } from '@atlassian/jira-tenant-context-controller/src/components/locale/index.tsx';
import { asyncWrmRequire } from '@atlassian/jira-wrm/src/async-wrm.tsx';
import calendarLocaleModule from '@atlassian/jira-wrm/src/common-modules/calendar-locale-module.tsx';
import { useIsModernGlobalIssueCreatePreferred } from './feature-flags.tsx';

export function loadWRM(): <T>({
	name,
	wrmKeys,
	tentatives,
	timeout,
	shouldLogError,
}: LoadBridgeOptions) => Promise<T> {
	/* eslint-disable jira/wrm/no-load-bridge */
	return fg('load-wrm-resource-for-gic') ? loadBridgeWeak : loadBridge;
}

const LoadGICResources = () => {
	const locale = useLocale();
	const isModernPreferredOld =
		useIsModernGlobalIssueCreatePreferred() &&
		fg('render_modern_global_issue_create_modal_experience');
	const isModernPreferred = fg('issue-create-stop-using-gicoptinstatusresources')
		? fg('render_modern_global_issue_create_modal_experience')
		: isModernPreferredOld;
	useEffect(() => {
		if (__SPA__) {
			(isModernPreferred ? waitForHeritage() : loadWRM()({ name: 'wrm/require' }))
				?.then(() =>
					asyncWrmRequire([
						'wrc!com.atlassian.jira.jira-quick-edit-plugin:quick-create-issue',
						'wrc!com.atlassian.plugins.browser.metrics.browser-metrics-plugin:api',
						'wrc!jira.create.issue',
						calendarLocaleModule(locale),
						'wrc!com.atlassian.jira.plugins.jira-dnd-attachment-plugin:shared-utility',
						'wrc!com.pyxis.greenhopper.jira:gh-issue-type-whitelist',
						'wrc!com.atlassian.jira.plugins.jira-wiki-editor:wiki-editor-resources-init',
						'wrc!com.pyxis.greenhopper.jira:gh-view-issue',
						'wrc!com.pyxis.greenhopper.jira:gh-custom-field-pickers',
						'wrc!com.atlassian.jira.jira-atlaskit-plugin:sidebar',
					]),
				)
				.catch((error: Error) => {
					fireErrorAnalytics({
						meta: {
							id: 'LoadGICResources',
							packageName: 'jiraGlobalIssueCreateResources',
							teamName: 'gryffindor',
						},
						error,
					});
				});
		}
	}, [isModernPreferred, locale]);
	return null;
};
/* Code after clean up
const LoadGICResources = () => {
	const locale = useLocale();
	useEffect(() => {
		if (__SPA__) {
			(fg( 'render_modern_global_issue_create_modal_experience' ); ? waitForHeritage() : loadWRM()({ name: 'wrm/require' }))
				?.then(() =>
					asyncWrmRequire([
						'wrc!com.atlassian.jira.jira-quick-edit-plugin:quick-create-issue',
						'wrc!com.atlassian.plugins.browser.metrics.browser-metrics-plugin:api',
						'wrc!jira.create.issue',
						calendarLocaleModule(locale),
						'wrc!com.atlassian.jira.plugins.jira-dnd-attachment-plugin:shared-utility',
						'wrc!com.pyxis.greenhopper.jira:gh-issue-type-whitelist',
						'wrc!com.atlassian.jira.plugins.jira-wiki-editor:wiki-editor-resources-init',
						'wrc!com.pyxis.greenhopper.jira:gh-view-issue',
						'wrc!com.pyxis.greenhopper.jira:gh-custom-field-pickers',
						'wrc!com.atlassian.jira.jira-atlaskit-plugin:sidebar',
					]),
				)
				.catch((error: Error) => {
					fireErrorAnalytics({
						meta: {
							id: 'LoadGICResources',
							packageName: 'jiraGlobalIssueCreateResources',
							teamName: 'gryffindor',
						},
						error,
					});
				});
		}
	}, [locale]);
	return null;
};
*/
export default LoadGICResources;
